import Nav from "./nav.js";
import Header from "./header.js";
import About from "./about.js";
import Projects from "./projects.js";
import Contact from "./contact.js";
import Footer from "./footer.js";

function App() {
  return (
    <main>
      {/* ---------- Navigation ---------*/}
      <Nav />
      {/* ---------  Header    --------- */}
      <Header />
      {/* --------  About -------------- */}
      <About/>
      {/* -----------Projects ---------- */}
      <Projects />
      {/* --------- Contact ------------ */}
      <Contact />
      {/* --------- Footer ------------- */}
      <Footer/>
    </main>
  );
}

export default App;
